import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';
import Tooltip from './Tooltip';
import { Status } from '../../../../backend/shared/types';
import ItemStatus from './ItemStatus';
// @ts-ignore
import { hexToRgba } from 'hex-and-rgba';

const Panel = styled.div`
  width: 100%;
  border-top: 1px solid ${OMGTheme.colors.grayLightBorder};
  border-left: 1px solid ${OMGTheme.colors.grayLightBorder};
  border-right: 1px solid ${OMGTheme.colors.grayLightBorder};
  background-color: #FAFAFD;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: 72px;
  line-height: 72px;
  > div {
      justify-self: center;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    grid-template-columns: 1fr 1fr;
    background-color: #FFFFFF;
    > div {
      justify-self: left;
      padding-left: 10px;
    }
  }
`;

const TitleBox = styled.div`
  font-size: 18px;
  font-weight: 500;
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    font-size: 14px;
  }
`;

const Icon = styled.span`
  font-size: 14px; 
  vertical-align: top;
  margin-left: 5px;
  position: relative;
  cursor: help;
  :hover > div {
    display: block;
  }
`;

const SpacerBlock = styled.div`
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    display: none;
  }
`;

interface OrderStatusPanelProps {
  status: Status
}

const OrderStatusPanel: React.FC<OrderStatusPanelProps> = ({
  status
}) => {
  return (
    <Panel>
      <TitleBox>
        Fulfillment Status
          <Icon>
            <Tooltip
              title="Fulfillment Status"
              description="Fullfillment status allows you to see the status of your order. Hover over status name to get more details on your product orders."
            />
            <i className="fa fa-info-circle" aria-hidden="true"></i>
          </Icon>
      </TitleBox>
      <SpacerBlock />
      <ItemStatus
        status={status.name}
        statusDescription={status.description}
        statusColorHex={'#' + status.color}
        statusColorRgba={hexToRgba('#' + status.color)}
      />
    </Panel>
  );
};

export default OrderStatusPanel;
